// src/services/idleTimer.js

import store from '@/store'

const IdleTimer = {
  timeout: null,
  idleLimit: 15 * 60 * 1000, // 15 minutes
  _resetHandler: null,
  started: false, // <-- Track if it's running

  start() {
    if (this.started) {
      return
    }

    this._resetHandler = this.reset.bind(this)
    this.reset()
    window.addEventListener('mousemove', this._resetHandler)
    window.addEventListener('keydown', this._resetHandler)
    window.addEventListener('click', this._resetHandler)
    window.addEventListener('scroll', this._resetHandler)
    this.started = true
  },

  reset() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.logout()
    }, this.idleLimit)
  },

  async logout() {
    console.log('User inactive. Logging out...')
    await store.dispatch('setUser', null)
    const { default: router } = await import('@/router')
    if (router.currentRoute.value.name !== 'Home') {
      router.push({ name: 'Home' })
    }
    this.stop()
  },

  stop() {
    if (!this.started) {
      return
    }

    clearTimeout(this.timeout)
    if (this._resetHandler) {
      window.removeEventListener('mousemove', this._resetHandler)
      window.removeEventListener('keydown', this._resetHandler)
      window.removeEventListener('click', this._resetHandler)
      window.removeEventListener('scroll', this._resetHandler)
      this._resetHandler = null
    }
    this.started = false
  },
}

export default IdleTimer
